module.exports = __webpack_public_path__ + "img/Approved_01.76804963.svg";